import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    customBackdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#00000070',
      zIndex: 1200, // Lower than container (1301) but covers everything else
      cursor: 'pointer',
    },
    creditPopoverContainer: {
      position: 'relative',
      zIndex: 1302, // Above the backdrop (1200) and container (1301)
      width: '382px',
      height: '409px',
      borderRadius: '24px',
      background: '#FFF',
      boxShadow: '0 4px 4px 0 rgba(194, 194, 194, 0.25)',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: 'auto',
        minHeight: '300px',
        maxHeight: '90vh',
        padding: '12px',
        borderRadius: '16px',
        overflowY: 'auto',
      },
    },
    creditAmountsContainer: {
      display: 'flex',
      gap: '12px',
      marginBottom: '16px',
      [theme.breakpoints.down('md')]: {
        gap: '8px',
        marginBottom: '12px',
      },
    },
    creditBox: {
      flex: 1,
      display: 'flex',
      height: '84px',
      flexDirection: 'column',
      padding: '12px 16px',
      border: '1px solid #E9E9E9',
      borderRadius: '16px',
      background: '#FFFFFF',
      [theme.breakpoints.down('md')]: {
        height: 'auto',
        minHeight: '72px',
        padding: '10px 12px',
        borderRadius: '12px',
      },
    },
    creditLabel: {
      fontSize: '14px',
      color: '#000',
      fontWeight: 500,
      margin: '6px 0px',
      [theme.breakpoints.down('md')]: {
        margin: '4px 0px',
      },
    },
    creditAmount: {
      fontSize: '24px',
      fontWeight: 400,
      color: '#000',
      fontStyle: 'normal',
      lineHeight: '125.705%',
    },
    accruedLabelContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      margin: '6px 0px',
      [theme.breakpoints.down('md')]: {
        margin: '4px 0px',
        gap: '4px',
      },
    },
    accruedLabel: {
      fontSize: '14px',
      color: '#6E6E6D',
      fontWeight: 500,
    },
    infoIconCircle: {
      width: '16px',
      height: '16px',
      aspectRatio: '1/1',
      flexShrink: 0,
      borderRadius: '50%',
      border: '1px solid #A0A3A4',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#6E6E6D',
      fontFamily: '"General Grotesque"',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%',
      cursor: 'pointer',
      color: '#6E6E6D',
      fontFamily: '"General Grotesque"',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%',
      marginLeft: '10px',
      marginBottom: '-2px',
    },
    accruedAmount: {
      fontSize: '24px',
      fontWeight: 400,
      color: '#6E6E6D',
      fontStyle: 'normal',
      lineHeight: '125.705%',
    },
    creditSectionContent: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '15px',
      gap: '8px',
      [theme.breakpoints.down('md')]: {
        gap: '6px',
        marginBottom: '8px',
      },
    },
    creditDivider: {
      borderColor: '#E9E9E9',
      margin: '16px 0',
    },
    creditSectionTitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#000',
      margin: '16px 0px 18px 0px',
      [theme.breakpoints.down('md')]: {
        margin: '12px 0px 14px 0px',
      },
    },
    creditListItem: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: '12px',
      paddingRight: '12px',
      cursor: 'pointer',
      marginBottom: '8px',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
      [theme.breakpoints.down('md')]: {
        borderRadius: '10px',
        paddingRight: '8px',
        marginBottom: '6px',
      },
    },
    creditListItemDisabled: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: 0,
      paddingRight: '12px',
      cursor: 'default',
      marginBottom: '8px',
      marginLeft: '-16px',
      marginRight: '-16px',
      paddingTop: '5px',
      paddingBottom: '5px',
      marginTop: '-5px',
      marginBottom: '-5px',
      paddingLeft: '16px',
      position: 'relative',
      pointerEvents: 'auto',
      [theme.breakpoints.down('md')]: {
        borderRadius: 0,
        paddingRight: '8px',
        marginBottom: '6px',
        marginLeft: '-12px',
        marginRight: '-12px',
        paddingLeft: '12px',
      },
    },
    creditListItemOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(217, 217, 217, 0.60)',
      pointerEvents: 'none',
      zIndex: 10,
    },
    creditIconBox: {
      width: '72px',
      height: '72px',
      borderRadius: '10px',
      background: '#FCFCCF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '12px',
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: '56px',
        height: '56px',
        borderRadius: '8px',
        marginRight: '10px',
      },
    },
    creditIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        '& svg': {
          width: '50px',
          height: '50px',
        },
      },
    },
    creditItemContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    creditItemTitle: {
      color: '#000',
      fontSize: '14px',
      margin: '0px 0px 4px 0px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%', // 17.599px
      [theme.breakpoints.down('md')]: {
        margin: '0px 0px 3px 0px',
      },
    },
    creditItemSubtextContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      [theme.breakpoints.down('md')]: {
        gap: '4px',
      },
    },
    creditItemSubtext: {
      color: '#6E6E6D;',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '125.705%', // 17.599px
    },
    creditArrow: {
      marginLeft: '12px',
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        marginLeft: '8px',
        width: '16px',
        height: '16px',
      },
    },
    creditArrowDisabled: {
      marginRight: '15px', // Compensate for negative padding on disabled button
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        marginLeft: '-4px', // Compensate for negative padding on disabled button
        width: '16px',
        height: '16px',
      },
    },
    creditHistoryRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px 22px 12px 10px',
      cursor: 'pointer',
      borderRadius: '12px',
      transition: 'background-color 0.2s',
      marginTop: '8px',
      marginLeft: '-10px',
      marginRight: '-10px',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
      [theme.breakpoints.down('md')]: {
        padding: '10px 16px 10px 10px',
        borderRadius: '10px',
        marginTop: '6px',
        marginLeft: '-4px',
        marginRight: '-4px',
      },
    },
    creditHistoryDivider: {
      padding: '10px 0px 0px 0px',
    },
    creditHistoryText: {
      color: '#000',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '125.705%', // 17.599px
    },
  }),
  { name: 'CreditPopover' },
);

export default useStyles;
